import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const reviews = [{
  text: 'Mio figlio di 7 anni ha costruito il suo primo robot in 20 minuti e da allora non ha più chiesto il tablet. I soldi meglio spesi da quando sono genitore.',
  name: 'Jessica M.',
  meta: 'Mamma di 2 · Texas, USA',
  letter: 'J',
  color: 'bg-brand',
  textTone: 'text-white',
  tone: 'bg-brand-light'
}, {
  text: 'All’inizio ero scettica — “l’ennesimo prodotto digitale” — ma le guide sono così chiare che perfino io sono riuscita a seguirle. Mia figlia ne è ossessionata.',
  name: 'Sarah K.',
  meta: 'Mamma di 3 · Londra, Regno Unito',
  letter: 'S',
  color: 'bg-mint',
  textTone: 'text-ink',
  tone: 'bg-mint-light'
}, {
  text: 'Ora facciamo un progetto ogni sabato mattina. Mio figlio lo chiama “il giorno dei robot”. Ha imparato più sull’ingegneria in due mesi che in un intero anno scolastico.',
  name: 'Michael R.',
  meta: 'Papà di 1 · Sydney, Australia',
  letter: 'M',
  color: 'bg-sky',
  textTone: 'text-ink',
  tone: 'bg-sky-light'
}, {
  text: 'Il tracker dei progressi in omaggio è stata un’idea geniale. I miei figli fanno a gara a chi completa più progetti. Le liti per gli schermi sono quasi sparite.',
  name: 'Rachel T.',
  meta: 'Mamma di 4 · Toronto, Canada',
  letter: 'R',
  color: 'bg-sunshine',
  textTone: 'text-ink',
  tone: 'bg-sunshine-light'
}, {
  text: 'L’ho scaricato venerdì sera, ho stampato la guida rapida e prima di andare a letto avevamo un robot funzionante. Mia figlia di 5 anni era così orgogliosa. Vale ogni centesimo.',
  name: 'Laura B.',
  meta: 'Mamma di 2 · Madrid, Spagna',
  letter: 'L',
  color: 'bg-coral',
  textTone: 'text-ink',
  tone: 'bg-coral-light'
}];
function Stars() {
  return <div className="flex text-amber-400" aria-hidden="true" data-id="element-181" data-mp="1nma80j39h10s">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-current" data-id="element-182" data-mp="1xhh4lrbxj3jk" data-mpi={i} />)}
    </div>;
}
export function Testimonials() {
  return <section className="w-full bg-white py-16 sm:py-24" data-id="element-183" data-mp="1sh37h4bv9e0b">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-184" data-mp="1og9g20z7th2o">
        <SectionHeading eyebrow="Cosa dicono i genitori" title={<>Famiglie vere. Risultati veri.</>} subtitle="Oltre 2.000 famiglie hanno già usato MakerLab per allontanare i figli dagli schermi e costruire qualcosa di concreto. Ecco cosa dicono." data-id="element-185" data-mp="1ji80hq0zzzvy" />

        <div className="mt-8 flex items-center justify-center gap-3" data-id="element-186" data-mp="19qlgp5algshl">
          <Stars data-id="element-187" data-mp="14tv5owdncn31" />
          <p className="text-sm font-semibold text-ink" data-id="element-188" data-mp="14r8soh7zlfdf">
            Oltre 2.000 famiglie — media di 4,9 su 5
          </p>
        </div>

        <div className="mt-12 columns-1 gap-6 sm:columns-2 lg:columns-3 [&>*]:mb-6" data-id="element-189" data-mp="vt6mln9ebwja">
          {reviews.map((r, i) => <motion.figure key={r.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: i % 3 * 0.08
        }} className={`break-inside-avoid rounded-3xl border border-ink/10 p-6 ${r.tone}`} data-id="element-190" data-mp="quvdjeqxdq24" data-mpi={i}>
              <Stars data-id="element-191" data-mp="2oozh2pniosmw" />
              <blockquote className="mt-3 text-sm leading-relaxed text-ink/80" data-id="element-192" data-mp="2oqkc0gdqudla">
                “{r.text}”
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3" data-id="element-193" data-mp="2sozuq82skzsw">
                <span className={`flex h-10 w-10 items-center justify-center rounded-full text-sm font-bold ${r.color} ${r.textTone}`} data-id="element-194" data-mp="2ximbocfznpui">
                  {r.letter}
                </span>
                <span data-id="element-195" data-mp="24zp59mqw6ru2">
                  <span className="block text-sm font-bold text-ink" data-id="element-196" data-mp="1lwwo9xex6ujk">
                    {r.name}
                  </span>
                  <span className="block text-xs text-ink/50" data-id="element-197" data-mp="1gybxeolk5n7s">{r.meta}</span>
                </span>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}